import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { blue, red, yellow } from '@material-ui/core/colors';

const messages = [
  'Cargando datos...',
  'Por favor, espere...',
  '¡Estamos preparando todo para usted!',
  'Cargando...',
  '¡Estamos trabajando duro para obtener la información que necesita!',
  'Solo unos segundos más...',
  'Estamos casi listos...',
  'Solo un momento por favor...',
  'Gracias por su paciencia...',
  'Estamos en ello...',
  'Hemos recibido su solicitud y estamos procesándola...',
  'Solo un momento, estamos procesando su solicitud...'
];
const color=800
export const LoadingComponent = ({ label="", height = '50vh' }) => {
  const [loadingMessage, setLoadingMessage] = useState(label);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(false);

  useEffect(() => {
    let interval
    if(label.length > 0) {
      interval = setInterval(() => {
        setCount(prevCount => {
          if (prevCount > 1) {
            setActive(true);
          }
          return prevCount + 1;
        });
        
        const randomIndex = Math.floor(Math.random() * messages.length);
        const randomMessage = messages[randomIndex];
        setLoadingMessage(randomMessage);
      }, 8000);
    }
    return () => clearInterval(interval);
  }, []);

  return (
    <Box style={{ flex: 1, height: `${height}`, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
        <CircularProgress style={{
          color: active ? yellow[color] : blue[color]
        }}/>
        <Typography variant="caption" component="p" style={{
          color: active ? yellow[color] : blue[color]
        }}>{loadingMessage}</Typography>
      </Box>
    </Box>
  );
};
